import client from './client';

export const getProducts = () => client.get('/tracking/products');
export const createProduct = (name: string, url: string) =>
  client.post('/tracking/product', { name, url });
export const addKeywords = (product_id: number, keywords: string[]) =>
  client.post('/tracking/keyword', { product_id, keywords });
export const getHistory = (keyword_id: number) =>
  client.get(`/tracking/history/${keyword_id}`);
